// vuetify.js
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import 'vuetify/styles'

const DROPDOWN = {
  variant: 'outlined',
  density: 'compact',
  menuIcon: 'mdi-chevron-down',
  hideDetails: 'auto',
  noDataText: 'No options',
  menuProps: { maxHeight: 280 },
};

export default createVuetify({
  components,
  directives,
  // Flat buttons by default (Vuetify 3's default is the raised "elevated"
  // variant); see assets/css/buttons.css for the rest of the button look.
  defaults: {
    VBtn: {
      variant: 'flat',
    },
    // One field style everywhere: outlined, compact (40px), neutral focus.
    // No `color`: with color 'primary' the focused label, caret and chevron
    // took the school colour, which reads as an error on a red brand.
    // Without a variant Vuetify 3 renders the grey "filled" style. Fields
    // that set their own variant/density keep it. See assets/css/inputs.css.
    VTextField: { variant: 'outlined', density: 'compact' },
    // Dropdowns: no empty gap under the field until there is an error to
    // show, a scrolling menu instead of one taller than the dialog, and a
    // plain "No options" row. Autocompletes pick the first match on Enter.
    VSelect: { ...DROPDOWN },
    VAutocomplete: { ...DROPDOWN, autoSelectFirst: true, noDataText: 'No matches' },
    VCombobox: { ...DROPDOWN },
    VTextarea: { variant: 'outlined', density: 'compact' },
    VFileInput: { variant: 'outlined', density: 'compact' },
  },
  icons: {
    iconfont: "md",  // If you want to use Material Design Icons (md)
  },
  // Vuetify 3 reads theme colours from `colors`; the previous Vuetify 2
  // style keys (primary1, submitBtns, success: grey…) were silently ignored,
  // so color="primary" rendered Vuetify's default blue. Only the brand colour
  // is set; success/error/warning/info keep Vuetify's defaults.
  theme: {
    themes: {
      // Surfaces match the shadcn tokens in global.css; the dark theme is
      // switched on by composables/useAppearance.js.
      light: {
        dark: false,
        colors: {
          // Both follow the school's colour, set at startup by branding.js.
          primary: '#E35E93',
          brand: '#E35E93',
          background: '#FFFFFF',
          surface: '#FFFFFF',
          'on-surface': '#0A0A0A',
          'on-background': '#0A0A0A',
        },
      },
      dark: {
        dark: true,
        colors: {
          // Both follow the school's colour, set at startup by branding.js.
          primary: '#E35E93',
          brand: '#E35E93',
          background: '#0A0A0A',
          surface: '#171717',
          'surface-bright': '#262626',
          'surface-variant': '#A3A3A3',
          'on-surface': '#FAFAFA',
          'on-background': '#FAFAFA',
        },
      },
    },
  },
  //   display: {
  //   mobileBreakpoint: 'xs',
  //   thresholds: {
  //     xs: 9999, // forces everything to be treated as 'xs'
  //     sm: 9999,
  //     md: 9999,
  //     lg: 9999,
  //     xl: 9999,
  //   },
  // },
});
